module.exports = __webpack_public_path__ + "img/SK.2d5acfa2.svg";